import { Injectable } from "@angular/core";
import { Title } from "@angular/platform-browser";
import { Observable, of } from "rxjs";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { map, share } from "rxjs/operators";

import {
	GlobalDomOpsService,
	CommonOperationsService,
	GlobalDataOpsService,
	AcepSSOService
} from "@acepteam/globalspack";
import { DomService } from "./dom.service";
import { LoggerService } from "./logger.service";
import { HelperService } from "./helper.service";

import { environment } from "../../../environments/environment";
import {
	Address,
	AppUiData,
	Questionnaire
} from "../../shared/models/common.data.models";
import { ChapterLobby } from "src/app/shared/models/chapter-lobby";

declare var $: any;
declare var moment: any;

@Injectable({
	providedIn: "root"
})
export class DataService {
	//public headers: Headers;
	public localbase = environment.localbase;
	public contactapiendpoint = environment.contactapiendpoint;
	public memberappapiendpoint = environment.memberappapiendpoint;
	public dashboardapiendpoint = environment.dashboardapiendpoint;
	public ninjaapiendpoint = environment.ninjaapiendpoint;
	public s3endPoint = environment.s3endPoint;
	public navigationDirection = "next";
	public email_from = "donotreply@acep.org";
	public email_to = "membership@acep.org";
	public email_cc = "devops@acep.org";
	public routename: string = "home";
	public uidata: AppUiData = null;
	public chapterLobbydata: ChapterLobby[] = null;
	public IsFromGroupPortal: boolean;

	//Private properties
	private UIData$ = this.http
		.get(this.ninjaapiendpoint + "RunSproc?sp=acepsp_acepmembershipdata")
		.pipe(
			map((res: Response) => this.processUIData(res)),
			share()
		);


	private ChapterLobbyData$ = this.http.get(this.memberappapiendpoint + "GetChapterLobbyInfo", { headers: new HttpHeaders({ "x-noauth": "true", 'Content-Type': 'application/json' }) })
		.pipe(
			map((res: Response) => this.processChapterLobbyData(res)),
			share()
		);

	constructor(
		private globalDomOpsService: GlobalDomOpsService,
		private domService: DomService,
		private globalDataOpsService: GlobalDataOpsService,
		private commonOpsService: CommonOperationsService,
		private helperService: HelperService,
		private ssoService: AcepSSOService,
		private titleService: Title,
		private loggerService: LoggerService,
		private http: HttpClient
	) { }

	GetUIData(): any {
		//console.log('data service calling GetUIData stats.');
		if (this.uidata) {
			return of(this.uidata);
		}
		return this.UIData$;
	}

	processUIData(response: Response | any) {
		let json_uidata = response;
		this.uidata = json_uidata;
		this.MapUIData(json_uidata);
		return this.uidata;
	}

	private MapUIData(jsondata) {
		this.uidata = new AppUiData();
		let data = jsondata;

		this.uidata.Countries = data[0];
		this.uidata.StateProvinces = data[1];
		this.uidata.Gender = data[2];
		this.uidata.Prefix = data[3].filter(a => a.label.indexOf("Deprecated") == -1);
		this.uidata.Ethnicity = data[4];
		this.uidata.MilitaryBranch = data[5];
		this.uidata.MilitaryRank = data[6];
		this.uidata.MedicalSchools = this.helperService.movemanualItemToEnd(
			data[7]
		);
		this.uidata.Residencies = this.helperService.movemanualItemToEnd(
			data[8]
		);
		this.uidata.Fellowships = this.helperService.movemanualItemToEnd(
			data[9]
		);
		this.uidata.Speciality = data[10];
		this.uidata.SubSpeciality = data[11];
		this.uidata.BoardCertifications = this.helperService.movemanualItemToEnd(
			this.SortBoardCertificationsBasedOnOrg(data[12])
		);
		this.uidata.MedicalLicenseTypeCodes = data[13];
		this.uidata.ManualAccounts = data[14];
		this.uidata.CareerStatus = data[15];
		this.uidata.Sections = data[18];
		this.uidata.Chapters = data[19];
		//this.uidata.AccountProducts = data[20];

		this.uidata.Pronouns = data[21];
		this.uidata.SexualOrientations = data[22];
		this.uidata.PrimaryLanguages = data[23];
		this.uidata.Disabilities = data[24];
		this.uidata.PrimaryPracticeGeography = data[25];
		this.uidata.PrimaryPracticeSettings = data[26];
		this.uidata.PrimaryReasonForJoining = data[27];


		//Sanitize
		// this.uidata.Ethnicity = this.helperService.sortObjectArray(
		// 	this.uidata.Ethnicity,
		// 	true
		// );

		//set group portal flag
		this.IsFromGroupPortal = window.location.href.indexOf('gp') > -1;
	}


	GetChapterlobbyData(): any {
		//console.log('data service calling GetUIData stats.');
		if (this.chapterLobbydata) {
			return of(this.chapterLobbydata);
		}
		return this.ChapterLobbyData$;
	}

	processChapterLobbyData(response: Response | any) {
		let json_lobbydata = response;
		this.chapterLobbydata = json_lobbydata;
		return this.chapterLobbydata;
	}

	get IsSectionApplication() {
		return window.location.href.indexOf('sectionapp') > -1
	}

	get IsRetirementApplication() {
		return window.location.href.indexOf('retired') > -1
	}

	get IsLobbyPage() {
		return window.location.href.indexOf('lobby') > -1
	}




	private SortBoardCertificationsBasedOnOrg(jRows) {
		let jRows_ACEP = jRows.filter(j => j.org != 3);
		return jRows_ACEP;
	}

	handleError(error: Response | any): Observable<any> {
		console.error(error);
		return Observable.throw(error.json().error || "Server error");
	}

	public CreateQuestionnaireObject(
		QuestionDefinitions: any,
		key: string = "",
		dbData?: any,
		uniquemetadata = ""
	) {
		let q: Questionnaire = {
			questiontext: "",
			qndefnid: "",
			questionKey: key,
			answerid: "",
			answertype: "",
			answervalue: "",
			answermetadata: uniquemetadata,
			answernotes: "",
			modifiedon: ""
		};

		//If no key return empty object - > Used in Payload instantiaition in constructor
		if (key.length == 0) {
			return q;
		}
		//debugger;
		q = this.SynchQuestionnaireDefinitionProperties(q, QuestionDefinitions);

		if (dbData) {
			q = this.SynchQuestionnareAnswerProperties(q, dbData);
		}

		return q;
	}

	private SynchQuestionnaireDefinitionProperties(
		q: Questionnaire,
		QuestionDefinitions: any
	) {
		if (q.qndefnid.length == 0) {
			//ADD ONLY IF NO QN DEFN ID//
			//let jrow = this.uidata == null ? this.uidata : this.uidata.Questionnaire.filter(function (s) { return s.acep_QuestionnaireKey === q.questionKey });

			let jrow = QuestionDefinitions.filter(function (s) {
				return s.acep_QuestionnaireKey === q.questionKey;
			});

			if (jrow && jrow.length > 0) {
				q.questiontext = jrow[0].Acep_name;
				q.qndefnid = jrow[0].acep_questionnairedefinitionId;
				q.answertype = jrow[0].acep_questiontype;
			}
		}
		return q;
	}

	private SynchQuestionnareAnswerProperties(q: Questionnaire, jtable: any) {
		//debugger;
		// let jrow = jtable.filter(function (s) { return s.acep_QuestionnaireKey === q.questionKey });
		let jrow =
			q.questionKey.toLowerCase().indexOf("manual") > -1
				? jtable.filter(function (s) {
					return (
						s.Acep_QuestionnaireAnswerId === q.answerid ||
						s.Acep_AnswerMetadata === q.answermetadata
					);
				})
				: jtable.filter(function (s) {
					return s.acep_QuestionnaireKey === q.questionKey;
				});
		// if(jrow.length == 0)
		// {
		//     jrow = jtable.filter(function (s) { return s.acep_QuestionnaireKey === q.questionKey });

		// }

		let janswer = "";
		let janswermeta = "";
		let jmodifedon = "";
		let janswerid = "";
		if (jrow && jrow.length > 0) {
			janswer = jrow[0].Acep_Answer;
			janswerid = jrow[0].Acep_QuestionnaireAnswerId;
			janswermeta = jrow[0].Acep_AnswerMetadata;
			jmodifedon = jrow[0].modifiedon;
		}
		q.answervalue = janswer;
		q.answerid = janswerid;
		q.answermetadata = janswermeta;
		q.modifiedon = jmodifedon;
		return q;
	}

	// UpdateQuestionnaire(q: Questionnaire, contactid: any) {
	//     let payload = { contactid: contactid, q: q };
	//     return this.http.post(this.contactapiendpoint + 'UpdateQuestionnaire', JSON.stringify(payload)).map((res: Response) => { return res.json() });

	// }

	//LOCAL STORAGE APIS
	GetFromLocalStorage(key: string) {
		key = this.ssoService.acepid + key;
		return localStorage.getItem(key);
	}
	SaveInLocalStorage(key: string, val: string) {
		key = this.ssoService.acepid + key;
		localStorage.setItem(key, val);
	}
	RemoveFromLocalStorage(key: string) {
		key = this.ssoService.acepid + key;
		localStorage.removeItem(key);
	}
}
